import { Query, Role, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { generateMockMobileDevice } from 'mocks/graphqlMocks/mobileDevice';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';
import { generateMockVisitorGroupMembership } from 'mocks/graphqlMocks/visitorGroupMembership';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

export function getAdminVisitorGroupsForTenant(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

const fieldsToRemoveFromVisitorGroups: (keyof VisitorGroup)[] = [
  'isAdminGroup',
  'isQrCodeVisitInviterGroup',
  'maxNumberOfMembers',
  'tenantId'
];

export const mockedGetAdminVisitorGroupsForTenantDataForQuery = getAdminVisitorGroupsForTenant([
  removeFields(
    generateMockVisitorGroup({
      id: 'mockedAdminVisitorGroupId',
      members: [
        generateMockVisitor({
          id: 'mockedVisitorIdExternalUser1',
          name: 'mockedVisitorNameExternalUser1',
          email: 'mockedVisitorEmailExternalUser1',
          mobileDevices: [generateMockMobileDevice({ id: 'mockedMobileDevice', isRegistered: false })],
          isEditable: true,
          visitorGroupMembership: [
            generateMockVisitorGroupMembership({
              visitorGroup: generateMockVisitorGroup({
                id: 'mockedVisitorGroupIdExternalUsers1'
              }),
              role: Role.ExternalGroupUser
            })
          ]
        })
      ],
      type: VisitorGroupType.Administrators,
      externalRef: 'mockedAdminVisitorGroupExternalRefs'
    }),
    fieldsToRemoveFromVisitorGroups
  )
]);
